import { render } from "./EmployeeApprovedPrs.vue?vue&type=template&id=2f7d1775"
import script from "./EmployeeApprovedPrs.vue?vue&type=script&lang=js"
export * from "./EmployeeApprovedPrs.vue?vue&type=script&lang=js"

import "./EmployeeApprovedPrs.vue?vue&type=style&index=0&id=2f7d1775&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__